module.exports = __webpack_public_path__ + "assets/img/ic-intro-ticket.60932797.png";